const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLoadingArrowmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5c2.56 0 4.819 1.29 6.171 3.254l1.133-1.133a.471.471 0 0 1 .805.333v3.575c0 .26-.211.471-.471.471h-3.575a.471.471 0 0 1-.333-.804l1.359-1.36A5.99 5.99 0 0 0 10 4c-3.309 0-6 2.691-6 6s2.691 6 6 6c2.968 0 5.432-2.167 5.91-5h1.515c-.491 3.663-3.629 6.5-7.425 6.5-4.136 0-7.5-3.364-7.5-7.5S5.864 2.5 10 2.5",
    fill: "currentColor",
    style: {
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLoadingArrowmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_loading_arrow.min.dc87f81d57a81f6d45ce95c9b1ae745d.svg";